module.exports = __webpack_public_path__ + "img/13.19379e4a.jpg";